import {
  TextInput,
  required,
  NumberInput,
  SelectInput,
  ReferenceInput,
  SimpleFormIterator,
  ArrayInput,
  BooleanInput,
} from "react-admin";
import { Grid, Typography } from "@mui/material";
import { settings } from "app";
import { administrationRequests } from "api/administrationApi";

const SaveForm = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        md={6}
        xs={12}
      >
        <TextInput
          label="Име на български език"
          source="nameBg"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        md={6}
        xs={12}
      >
        <TextInput
          label="Име на английски език"
          source="nameEn"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={12}
      >
        <Typography color={"primary"}>Отстъпки</Typography>
      </Grid>
      <Grid
        item
        xs={12}
        md={12}
      >
        <ArrayInput
          source="discounts"
          label=" "
          defaultValue={[{}]}
        >
          <SimpleFormIterator
            disableReordering
            sx={settings.style.iteratorWithoutGap}
          >
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                xs={12}
                md={6}
              >
                <ReferenceInput
                  source="taxTypeId"
                  reference={administrationRequests.getTaxTypesSelect()}
                >
                  <SelectInput
                    label="Такса"
                    validate={required()}
                  />
                </ReferenceInput>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
              >
                <NumberInput
                  label="Процент"
                  source="percentage"
                  validate={required()}
                />
              </Grid>
            </Grid>
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={12}
      >
        <Typography color={"primary"}>Документи</Typography>
      </Grid>
      <Grid
        item
        xs={12}
        md={12}
      >
        <ArrayInput
          source="documentTypes"
          label=" "
          defaultValue={[{}]}
        >
          <SimpleFormIterator
            disableReordering
            sx={settings.style.iteratorWithoutGap}
          >
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                xs={12}
                md={6}
              >
                <ReferenceInput
                  source="id"
                  reference={administrationRequests.getPreferenceDocumentTypesSelect()}
                >
                  <SelectInput
                    label="Документ"
                    validate={required()}
                  />
                </ReferenceInput>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
              >
                <NumberInput
                  label="Брой"
                  source="count"
                  validate={required()}
                />
              </Grid>
            </Grid>
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>
      <Grid
        item
        md={3}
        xs={12}
      >
        <BooleanInput
          label="Заявява се при кандидатстване"
          source="isZvo"
        />
      </Grid>
    </Grid>
  );
};
export default SaveForm;
